import React from 'react'
import { connect } from 'react-redux'

import { Alert } from '_components'

import './NotificationList.sass'

import { dismissNotification } from '_store/notifications/actions'

const mapStateToProps = (state) => ({
  collection: state.notifications.collection
})

export const NotificationList = connect(
    mapStateToProps,
    null
  )(({ dispatch, collection }) => (
    <div className={[
      'notification-list',
      ...(collection.length > 0 ? [] : ['empty'])
      ].join(' ')}>
      {collection.map(n =>
        <Alert
          key={n.id}
          contextualClass={n.contextualClass}
          onDismiss={() => dispatch(dismissNotification(n.id))}>
          {n.children}
        </Alert>
      )}
    </div>
  )
)
